import Sidebar from "../components/Sidebar";
import DealsBoard from "../components/deals/DealsBoard";

// Deals Board v2 — Phase 1 entry. Page is a thin shell; all logic in components/deals/.
const CRMDeals = ({ user, logout }) => {
  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar user={user} logout={logout} />
      <div className="flex-1 ml-64">
        <DealsBoard user={user} />
      </div>
    </div>
  );
};

export default CRMDeals;
